<template>
  <div :class="{'password-wrap':true, 'show':showForm || showMessage}">
    <div v-show="showForm">
      <!-- <p class="topLabel">
        {{ $t('provider.sendEmailLabel') }}
        <a class="button cta xsmall" @click="emailResetPassword">
          <span v-show="!passwordLoading.email">{{ $t('provider.sendToEmail') }}</span>
          <span v-show="passwordLoading.email">{{ $t('provider.sending') }}</span>
        </a>
      </p>

      <div class="or-hr">
        <span>{{ $t('provider.orTypeIn') }}</span>
      </div> -->

      <div class="field-row">
        <div class="data-field col col40">
          <div class="label">{{ $t('provider.basicInfo.password') }}</div>
          <input type="password" v-model="password.value"
            :class="{'input':true, 'has-error':password.hasError}" />
          <span class="error-msg">{{ password.message }}</span>
        </div>

        <div class="data-field col col40">
          <div class="label">{{ $t('provider.basicInfo.repassword') }}</div>
          <input type="password" v-model="repassword.value"
            :class="{'input':true, 'has-error':repassword.hasError}" />
          <span class="error-msg">{{ repassword.message }}</span>
        </div>

          <div class="data-field col col20 no-label">
            <a @click="resetPassword"
              :class="{'button cta warning block':true, 'disabled':passwordLoading.manual}">
              <span v-show="!passwordLoading.manual">{{ $t('provider.save') }}</span>
              <span v-show="passwordLoading.manual"><i class="fa fa-spinner fa-spin"></i></span>
            </a>
          </div>
        </div>
    </div>

    <div v-show="showMessage" :class="{'message-wrap':true, 'success':resetSuccess}">
      <i class="fa fa-check" v-show="resetSuccess"></i>
      <i class="fa fa-times" v-show="!resetSuccess"></i>
      {{ message }}
    </div>
  </div>
</template>

<script>

import ApiProvider from '../../modules/api/provider/user-info'

export default {
  name: 'reset-password',
  props: ['show'],
  data () {
    return {
      showForm: false,
      showMessage: false,
      message: '',
      resetSuccess: false,
      password: {
        value: '',
        hasError: false,
        message: ''
      },
      repassword: {
        value: '',
        hasError: false,
        message: ''
      },
      passwordLoading: {
        email: false,
        manual: false
      }
    }
  },
  computed: {
  },
  methods: {
    showResetPassword () {
      if (this.showMessage && !this.showForm) {
        this.showMessage = false
      } else {
        this.showForm = !this.showForm
      }
    },
    emailResetPassword () {
      let self = this
      self.passwordLoading.email = true
      ApiProvider.emailPassword(self, self.$store.state.provider.id, function (res) {
        self.passwordLoading.email = false
        self.showForm = false
        self.showMessage = true
        self.message = self.$t('provider.passwordSent')
        self.resetSuccess = true

        if (res.error) {
          self.message = res.error.message
          self.resetSuccess = false
          return
        }

        setTimeout(function () {
          self.showMessage = false
        }, 5000)
      })
    },
    resetPassword () {
      let self = this
      self.password.hasError = false
      self.password.message = ''
      self.repassword.hasError = false
      self.repassword.message = ''

      if (self.password.value !== self.repassword.value) {
        self.password.hasError = true
        self.repassword.hasError = true
        self.password.message = self.$t('provider.passwordNotMatch')
      }

      if (self.password.value === '') {
        self.password.hasError = true
        self.password.message = self.$t('provider.emptyField')
      }

      if (self.repassword.value === '') {
        self.repassword.hasError = true
        self.repassword.message = self.$t('provider.emptyField')
      }

      if (!self.password.hasError && !self.repassword.hasError) {
        let data = {
          id: self.$store.state.provider.id,
          password: self.password.value
        }

        self.passwordLoading.manual = true
        ApiProvider.updatePassword(self, data, function (res) {
         self.passwordLoading.manual = false
         self.showForm = false
         self.showMessage = true
         self.resetSuccess = true
         self.message = self.$t('provider.passwordSuccess')

         if (res.error) {
           self.resetSuccess = false
           self.message = res.error.message
         }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.field-row{
  box-sizing: border-box;
  display: flex;

  .col{ display: inline-block; }
  .col20{ width: 20%; }
  .col25{ width: 25%; }
  .col40{ width: 40%; }
  .col50{ width: 50%; }
  .col60{ width: 60%; }
  .col80{ width: 80%; }
  .col100{ width: 100%; }
}

.data-field{
  padding-right: 10px;

  &.no-label{ padding-top: 17px; }
  .label{
    color: #888;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;
  }
  .input{
    margin: 5px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.password-wrap{
  padding: 15px;
  background: #fafafa;
  border:1px solid #eaeaea;
  margin-top:10px;
  position: absolute;
  top: 0;
  left: 0;

  .topLabel{
    text-align: center;
    margin: 0;
    font-size: 14px;
    color: #333;
    padding-bottom: 15px;

    a{ vertical-align: middle; }
  }
  .or-hr{
    text-align: center;
    margin-bottom:15px;
    font-size: 14px;
    color: #444;
    position: relative;

    span{
      position: relative;
      z-index: 2;
      display: inline-block;
      padding: 0 15px;
      background: #fafafa;
      font-style: italic;
    }
    &:before{
      content: '';
      border-bottom: 1px solid #eaeaea;
      position: absolute;
      width: 100%;
      height: 1px;
      top:50%;
      left: 0;
      z-index: 1;
    }
  }
  .message-wrap{
    text-align: center;
    color: #444;

    .fa{
      vertical-align: baseline;
      margin-right: 10px;
      color: #F20D0D;
    }
    &.success{
      .fa{
        color: #26d97a;
      }
    }
  }
  &.show{
    position: relative;
    -webkit-animation: slide-down .3s ease-out;
    -moz-animation: slide-down .3s ease-out;
  }
}

@-webkit-keyframes slide-down {
  0% { opacity: 0; -webkit-transform: translateY(-100%); }
  100% { opacity: 1; -webkit-transform: translateY(0); }
}
@-moz-keyframes slide-down {
  0% { opacity: 0; -moz-transform: translateY(-100%); }
  100% { opacity: 1; -moz-transform: translateY(0); }
}

@media only screen and (max-width: 430px) {
  .data-field .label { margin-top: 10px; }

  .field-row {
    flex-direction: column;
    .col40 {
      width: 100%;
    }
    .col20 {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/ResetPassword.vue